<template>
    <router-link v-bind="$props" custom v-slot="{ isActive, href, navigate }">
        <a
            v-bind="$attrs"
            :href="href"
            @click="navigate"
            :class="isActive ? activeStyles : inactiveStyles">
            <slot/>
        </a>
    </router-link>
</template>

<script>
import {RouterLink} from 'vue-router';

export default {

    name: 'AppLink',

    inheritAttrs: false,

    props: {
        ...RouterLink.props,
        theme: String,
        inactiveClass: String,
    },

    computed: {
        themeStyles() {

            const themes = {
                'primary-button': {
                    main: `
                        px-3 py-2 rounded-full font-medium border bg-green text-teal-dark
                        focus:text-teal-dark focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-600
                        hover:bg-green-light
                        active:bg-green-dark
                    `.replace(/\s\s+/g, ' ').trim(),
                    active: 'border-green-dark',
                    inactive: 'border-green'
                }
            };

            return themes.hasOwnProperty(this.theme) ? themes[this.theme] : null;
        },
        activeStyles() {

            let styles = [
                this.activeClass,
            ];

            if (this.themeStyles) {
                styles.push(this.themeStyles.main);
                styles.push(this.themeStyles.active);
            }

            return styles;
        },
        inactiveStyles() {
            let styles = [
                this.inactiveClass,
            ];

            if (this.themeStyles) {
                styles.push(this.themeStyles.main);
                styles.push(this.themeStyles.inactive);
            }

            return styles;
        }
    },
}
</script>
